// User Profile API Service

import { api } from './api';

// Types
export interface UserProfile {
  id: string;
  email: string;
  name: string;
  profileImageUrl: string | null;
  subscriptionTier: string;
  languagePreference: string;
  timezone: string;
  activeProjectCount: number;
  createdAt: string;
  updatedAt: string | null;
}

export interface UpdateProfileRequest {
  name: string;
  profileImageUrl?: string | null;
}

export interface UpdatePreferencesRequest {
  languagePreference: string;
  timezone: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export interface FileUploadResponse {
  fileKey: string;
  url: string;
  fileName: string;
  contentType: string;
  size: number;
}

// User API functions
export const userApi = {
  // Get current user's profile
  async getProfile(): Promise<UserProfile> {
    return api.get<UserProfile>('/users/me');
  },

  // Update profile (name and profile image)
  async updateProfile(data: UpdateProfileRequest): Promise<UserProfile> {
    return api.put<UserProfile>('/users/me/profile', data);
  },

  // Update preferences (language and timezone)
  async updatePreferences(data: UpdatePreferencesRequest): Promise<UserProfile> {
    return api.put<UserProfile>('/users/me/preferences', data);
  },

  // Upload profile picture
  async uploadProfilePicture(file: File): Promise<FileUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const token = localStorage.getItem('accessToken');
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5202/api';

    const response = await fetch(`${API_BASE_URL}/files/upload?folder=profile-pictures`, {
      method: 'POST',
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to upload file');
    }

    return response.json();
  },
};
